import React, { useContext } from 'react'
import { stepExists } from 'app/React/Helpers/StepHelper'
import clx from 'classnames'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function StepLink(props) {
  const {
    currentVariant,
    strings,
    setCurrentStep,
  } = useContext(ConfiguratorContext)

  const steps = currentVariant.steps ?? {}
  const nextString = strings.navigation?.next ?? 'Næste'
  const label = props.label === null ? nextString : props.label

  const changeStep = function () {
    if (stepExists(steps, props.step_id)) {
      setCurrentStep(props.step_id)
    }
    // TODO: Make change step validate and make function global for use in footer
  }


  return (
    <a
      role='button'
      onClick={changeStep}
      id={props.html_id}
      className={clx({ disabled: !stepExists(steps, props.step_id) })}
    >
      {label}
    </a>
  )
}

StepLink.defaultProps = {
  step_id: 1,
  label: null,
  html_id: null
}

export default StepLink
